module.exports = __webpack_public_path__ + "static/img/pd_top_4.c71a9d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_top_4.jpg
// module id = xF27
// module chunks = 52